import React from 'react';

const PrivacyPolicy = () => {
    return (
        <section className="py-12 bg-gradient-to-b from-black to-gray-900 text-white">
            <div className="container mx-auto px-4 max-w-4xl">
                <div className="mb-12 border-b border-purple-500 pb-4">
                    <h1 className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-500">
                        Políticas de Privacidad de Stupid Comedy
                    </h1>
                    <p className="text-gray-400 mt-4">Última actualización: 28 de Junio de 2024</p>
                </div>

                <div className="prose prose-lg prose-invert max-w-none">
                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">1. Introducción</h3>
                        <p className="text-gray-300">
                            Bienvenido a Stupid Comedy. En Stupid Comedy, valoramos y respetamos su privacidad. Esta Política de Privacidad describe cómo recopilamos, utilizamos, divulgamos y protegemos su información personal cuando utiliza nuestra plataforma de streaming.
                        </p>
                    </div>

                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">2. Información que Recopilamos</h3>

                        <div className="mb-6">
                            <h4 className="text-xl font-semibold mb-3 flex items-center">
                                <span className="inline-block h-2 w-2 rounded-full bg-pink-500 mr-2"></span>
                                <span className="text-pink-200">Información que Usted Nos Proporciona</span>
                            </h4>
                            <ul className="space-y-3 pl-6">
                                <li className="flex items-start">
                                    <span className="text-purple-400 mr-2">•</span>
                                    <div><span className="font-semibold text-white">Registro y Cuenta:</span> Cuando se registra en Stupid Comedy, recopilamos información como su nombre, dirección de correo electrónico, número de teléfono y detalles de pago.</div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-purple-400 mr-2">•</span>
                                    <div><span className="font-semibold text-white">Contenido Generado por el Usuario:</span> Cualquier contenido que usted suba, publique o comparta en nuestra plataforma, como comentarios, reseñas y comunicaciones con nuestro equipo de soporte.</div>
                                </li>
                            </ul>
                        </div>

                        <div className="mb-6">
                            <h4 className="text-xl font-semibold mb-3 flex items-center">
                                <span className="inline-block h-2 w-2 rounded-full bg-pink-500 mr-2"></span>
                                <span className="text-pink-200">Información Recopilada Automáticamente</span>
                            </h4>
                            <ul className="space-y-3 pl-6">
                                <li className="flex items-start">
                                    <span className="text-purple-400 mr-2">•</span>
                                    <div><span className="font-semibold text-white">Datos de Uso:</span> Recopilamos información sobre su interacción con nuestra plataforma, incluyendo el contenido que ve, la duración de sus sesiones y sus preferencias de visualización.</div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-purple-400 mr-2">•</span>
                                    <div><span className="font-semibold text-white">Datos del Dispositivo:</span> Información sobre los dispositivos que utiliza para acceder a nuestra plataforma, incluyendo el tipo de dispositivo, sistema operativo, identificadores únicos del dispositivo y datos de red móvil.</div>
                                </li>
                            </ul>
                        </div>

                        <div className="mb-6">
                            <h4 className="text-xl font-semibold mb-3 flex items-center">
                                <span className="inline-block h-2 w-2 rounded-full bg-pink-500 mr-2"></span>
                                <span className="text-pink-200">Información de Terceros</span>
                            </h4>
                            <ul className="space-y-3 pl-6">
                                <li className="flex items-start">
                                    <span className="text-purple-400 mr-2">•</span>
                                    <div><span className="font-semibold text-white">Integraciones de Redes Sociales:</span> Si decide conectar su cuenta de Stupid Comedy con redes sociales u otras plataformas de terceros, podemos recibir información de estos servicios.</div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-purple-400 mr-2">•</span>
                                    <div><span className="font-semibold text-white">Proveedores de Servicios:</span> Podemos recibir información de nuestros proveedores de servicios, como datos de pago y verificación de identidad.</div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">3. Uso de la Información</h3>
                        <p className="text-gray-300 mb-4">Utilizamos su información personal para:</p>
                        <ul className="space-y-3 pl-6">
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Proveer el Servicio:</span> Para proporcionarle acceso a nuestra plataforma de streaming y personalizar su experiencia.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Mejorar Nuestro Servicio:</span> Analizar y mejorar la funcionalidad de nuestra plataforma y desarrollar nuevas características.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Comunicación:</span> Enviarle notificaciones sobre su cuenta, respuestas a sus consultas, actualizaciones y promociones.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Seguridad:</span> Detectar y prevenir fraudes, abusos y actividades ilegales.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Cumplimiento Legal:</span> Cumplir con obligaciones legales y regulatorias.</div>
                            </li>
                        </ul>
                    </div>

                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">4. Compartir Información</h3>
                        <p className="text-gray-300 mb-4">Podemos compartir su información con:</p>
                        <ul className="space-y-3 pl-6">
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Proveedores de Servicios:</span> Terceros que nos ayudan a operar nuestra plataforma, procesar pagos y proporcionar soporte al cliente.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Socios Comerciales:</span> Empresas con las que colaboramos para ofrecer contenido y promociones.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Autoridades Legales:</span> En respuesta a solicitudes legales, órdenes judiciales o en cumplimiento de leyes aplicables.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Transacciones Comerciales:</span> En el contexto de fusiones, adquisiciones o ventas de activos, su información puede ser transferida como parte de la transacción.</div>
                            </li>
                        </ul>
                    </div>

                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">5. Seguridad de la Información</h3>
                        <p className="text-gray-300">
                            Implementamos medidas de seguridad razonables para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción. Sin embargo, ningún método de transmisión o almacenamiento es completamente seguro, por lo que no podemos garantizar la seguridad absoluta.
                        </p>
                    </div>

                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">6. Sus Derechos</h3>
                        <p className="text-gray-300 mb-4">Usted tiene derecho a:</p>
                        <ul className="space-y-3 pl-6">
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Acceder y Corregir:</span> Solicitar acceso a la información personal que tenemos sobre usted y corregir cualquier error.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Eliminar:</span> Solicitar la eliminación de su información personal.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Oposición:</span> Oponerse al procesamiento de su información personal en ciertas circunstancias.</div>
                            </li>
                            <li className="flex items-start">
                                <span className="text-purple-400 mr-2">•</span>
                                <div><span className="font-semibold text-white">Portabilidad:</span> Solicitar la transferencia de su información personal a otra entidad.</div>
                            </li>
                        </ul>
                        <p className="text-gray-300 mt-4">
                            Para ejercer estos derechos, puede contactarnos a través de la información de contacto proporcionada a continuación.
                        </p>
                    </div>

                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">7. Retención de Datos</h3>
                        <p className="text-gray-300">
                            Retendremos su información personal durante el tiempo que sea necesario para cumplir con los propósitos descritos en esta Política de Privacidad, a menos que la ley requiera o permita un período de retención más largo.
                        </p>
                    </div>

                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">8. Cambios en esta Política de Privacidad</h3>
                        <p className="text-gray-300">
                            Podemos actualizar esta Política de Privacidad de vez en cuando. Le notificaremos sobre cualquier cambio mediante la publicación de la nueva política en nuestra plataforma y actualizando la fecha de "Última actualización".
                        </p>
                    </div>

                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">9. Contacto</h3>
                        <p className="text-gray-300 mb-4">
                            Si tiene alguna pregunta o inquietud sobre esta Política de Privacidad o nuestras prácticas de privacidad, puede contactarnos en:
                        </p>
                        <p className="text-gray-300 mb-4">
                            Stupid Comedy <br />
                            Correo electrónico: <a href="mailto:contacto@austranet.com" className="text-purple-300 hover:text-purple-100 transition">contacto@austranet.com</a>
                        </p>
                    </div>

                    <div className="mb-10 p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg">
                        <h3 className="text-2xl font-semibold mb-4 text-purple-300">10. Aceptación de la Política de Privacidad</h3>
                        <p className="text-gray-300">
                            Al utilizar nuestra plataforma, usted acepta los términos de esta Política de Privacidad. Si no está de acuerdo con esta política, por favor no utilice nuestra plataforma.
                        </p>
                    </div>

                    <div className="mt-16 p-6 bg-purple-900 bg-opacity-30 rounded-xl shadow-lg border border-purple-700">
                        <h3 className="text-2xl font-semibold mb-4 text-center text-white">Contacto</h3>
                        <div className="flex flex-col items-center justify-center">
                            <p className="text-center text-lg mb-3">
                                Si tiene alguna pregunta o inquietud sobre esta Política de Privacidad, puede contactarnos en:
                            </p>
                            <div className="bg-black bg-opacity-50 px-6 py-4 rounded-lg inline-block items-center text-center">
                                <p className="font-bold text-xl mb-2">Stupid Comedy</p>
                                <p className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-purple-400" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                    <a href="mailto:contacto@stupidcomedy.tv" className="text-purple-300 hover:text-purple-100 transition">
                                    contacto@stupidcomedy.tv
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PrivacyPolicy;